import React from 'react';
import { Pagination } from '@gin-betting/match-list';
import cd from 'debug';
import { OrderedSet } from 'immutable';
import { get } from 'lodash';

import { CustomVisibilitySensor } from '../CustomVisibilitySensor/CustomVisibilitySensor';
import SportEventRow, { StreamStub } from '../SportEventRow';

const debug = cd('app:match-list:components:ResultsMatchList');

interface Props {
    matchIds: OrderedSet<string>;
    isSmall: boolean;
    handleVisibilityChange?: Pagination.ReturnedPaginationProps['handleVisibilityChange'];
    visibilityInitRef?: Pagination.ReturnedPaginationProps['visibilityInitRef'];
}

class ResultsMatchList extends React.Component<Props> {
    getMatchIds = (): OrderedSet<string> => this.props.matchIds;

    render() {
        debug('render', this.props);
        const {
            matchIds,
            handleVisibilityChange,
            visibilityInitRef,
        } = this.props;

        const sportEventRows: JSX.Element[] = [];

        let prevMatchId: string | undefined;

        matchIds.delete('visibility1').forEach(matchId => {
            const component = matchId.match(/visibility/) ? (
                <CustomVisibilitySensor
                    key={matchId}
                    visibilityChange={handleVisibilityChange}
                    page={+get(matchId.match(/\d+$/), [0], 0)}
                    visibilityInitRef={visibilityInitRef}
                />
            ) : (
                <SportEventRow
                    key={matchId}
                    matchId={matchId}
                    prevMatchId={prevMatchId}
                    isResultPage={true}
                />
            );

            sportEventRows.push(component);

            prevMatchId = matchId.match(/visibility/) ? prevMatchId : matchId;
        });

        sportEventRows.push(<StreamStub key="stream-stub" />);

        return sportEventRows;
    }
}

export default ResultsMatchList;
